import React from 'react';
import { Group, NumberInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { ConfigFormValues } from './alertConfigurationConstants.ts';

interface Props {
    form: UseFormReturnType<ConfigFormValues>;
}

const QuestionnaireOverdueConditionFields: React.FC<Props> = ({ form }) => {
    const { t } = useTranslation();

    return (
        <Group grow align="flex-start">
            <NumberInput
                label={t('questionnaireOverdueReminder.thresholdDays')}
                description={t('questionnaireOverdueReminder.thresholdDaysDescription')}
                min={1}
                max={90}
                {...form.getInputProps('conditionThresholdDays')}
            />
            <NumberInput
                label={t('questionnaireOverdueReminder.maxReminders')}
                description={t('questionnaireOverdueReminder.maxRemindersDescription')}
                min={1}
                max={10}
                {...form.getInputProps('conditionMaxReminders')}
            />
        </Group>
    );
};

export default QuestionnaireOverdueConditionFields;
